import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "notesGrid note-red",
  style: {"width":"max-content"}
}
const _hoisted_2 = {
  style: {"grid-column":"indic"},
  class: "pad-s mtop-02"
}
const _hoisted_3 = {
  style: {"grid-column":"poso"},
  class: "row"
}
const _hoisted_4 = {
  key: 0,
  style: {"grid-column":"indic"},
  class: "pad-s mtop-06"
}
const _hoisted_5 = {
  style: {"grid-column":"indic"},
  class: "pad-s mtop-06"
}
const _hoisted_6 = {
  style: {"grid-column":"poso"},
  class: "mtop-06 col gap-02"
}

import { computed } from 'vue';
import { useCurrentEntryStore } from '@/stores/currentEntry';
import { apiDate } from '@/api/apicommon';
import { useAppUserStore } from '@/stores/appUser';
import gen from '@/functions/general.js';
import { getLatestExpr } from '@/functions/expression';


export default /*@__PURE__*/_defineComponent({
  __name: 'patientInfoBox',
  props: {
  info: {
    type: String, // 'ima', 'medic', 'vaccination'
    required: false,
  },
},
  setup(__props) {

const currentEntryStore = useCurrentEntryStore()
const appUserStore = useAppUserStore()

const props = __props

const age = computed(() => {
  if (!currentEntryStore.currentPatient) return ""
  return currentEntryStore.currentPatient.ageTerm
})

const patientAge = computed(() => {
  const entryDate = apiDate(currentEntryStore.currentEntryDate)
  const birthDate = apiDate(currentEntryStore.currentPatient?.birthDate)
  const timeDifference = entryDate - birthDate
  const years = timeDifference / (365 * 24 * 60 * 60 * 1000)
  return years
})

const showPregnancy = computed(() => {
  return currentEntryStore.currentPatient.biologicalSex === 'Female' && patientAge.value >= 12 && patientAge.value < 55
})

const alertTypeMap = {
  "Pregnancy" : "pregnancy",
  "Kidney" : "kidney",
  "Liver" : "liver",
  "Multi" : "person",
  "Medication" : "pill",
  "SubstanceReaction" : "allergy",
}

const substanceReactionList = computed(() => { 
  if (!currentEntryStore.hasCurrentEntry) {return []}

  const allExpressions = currentEntryStore.patientHistoryResponse;
  if (!allExpressions.length) return [];
  const allSubstReactExpr = allExpressions 
    .filter(expr => expr.isFamilyHistory === false && expr.expressionType === "None" && expr.originalText !== "" && expr.aggressorRootGroup === "SubstanceReaction")
    // .filter(expr => expr.aggressorContentRoot === filterStr)
    .map(expr => gen.deepCopy(expr))

  allSubstReactExpr.forEach(expr => {
    expr.ui = {
      "text" : expr.originalText,
      "exprDate": apiDate(expr.entry.entryStart).getFullYear().toString(), //gen.shortRelativeDate(expr.entry.entryStart, currEntryDate),
      "isNormal": expr ? expr.isNormal : null,
    }
  })

  return allSubstReactExpr
})

const alertList = computed(() => {
  let contextualizedAlerts = getContextualizedAlerts(props.info)
  if (!contextualizedAlerts) {return []}
  if (!currentEntryStore.hasCurrentEntry) {return []}

  //ContextualizedAlerts
  contextualizedAlerts = contextualizedAlerts
    .filter(alert => alert.isMatched == true)
    .filter(alert => showPregnancy.value || alert.refInternalType !== "Pregnancy")
    .map(expr => gen.deepCopy(expr))

  //Read more Data

  const allExpressions = currentEntryStore.allExpressions;
  const allValidExpr = allExpressions
    .filter(expr => expr.isFamilyHistory === false && expr.expressionType === "None" && expr.originalText !== "")
    .map(expr => gen.deepCopy(expr))

  //Create UI-Data for each alertExpr
  const addedAlertIcons = new Set()
  addedAlertIcons.add("person")
  for (let alertExpr of contextualizedAlerts) {
    //Create lastExpr
    const matchingExprArr = allValidExpr.filter(expr => expr.sctProxyKey === alertExpr.sctProxyKey)
    const lastExpr = getLatestExpr(matchingExprArr)
    //Add UI data
    alertExpr.ui = {
      "text" : alertExpr.originalText,
      "lastExpr" : lastExpr ? gen.deepCopy(lastExpr) : null,
      "lastExprDate": lastExpr ? apiDate(lastExpr.entry.entryStart).getFullYear().toString() : "",
      "lastExprText": lastExpr ? lastExpr.originalText : null,
      "isNormal": lastExpr ? lastExpr.isNormal : null,
    }
    //Icon
    const newIcon = alertTypeMap[alertExpr.refInternalType]
    if (!addedAlertIcons.has(newIcon)) {
      addedAlertIcons.add(newIcon)
      alertExpr.ui.icon = newIcon
    } else {
      alertExpr.ui.icon = ""
    }
  }
  return contextualizedAlerts
})

function getContextualizedAlerts(key) {
  if (!appUserStore.commonAlerts) {return null}
  const alerts = appUserStore.commonAlerts.internalReferences
  switch(key) {
    case "medic":
      return alerts.Medication
    case "ima":
      return alerts.Imaging
    case "vaccination":
      return alerts.Vaccination
    default:
      return null
  }
}


return (_ctx: any,_cache: any) => {
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_toolTip = _resolveComponent("toolTip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_svg_item, {
        icon: "person",
        styles: "size-m main-m"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_text_item, { txt: age.value }, null, 8, ["txt"])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alertList.value, (alertExpr, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        (alertExpr.ui.icon)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_svg_item, {
                icon: alertExpr.ui.icon,
                styles: "size-m main-m"
              }, null, 8, ["icon"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          style: {"grid-column":"poso","max-width":"22rem"},
          class: _normalizeClass(["row gap-06", alertExpr.ui.icon ? 'mtop-04' : ''])
        }, [
          (alertExpr.ui.lastExpr)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_text_item, {
                  txt: alertExpr.ui.lastExprText,
                  class: _normalizeClass(alertExpr.ui.isNormal ? '' : 'main-alert')
                }, null, 8, ["txt", "class"]),
                _createVNode(_component_text_item, {
                  txt: alertExpr.ui.lastExprDate,
                  class: "font-s main-l",
                  style: {"min-width":"max-content"}
                }, null, 8, ["txt"])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_text_item, {
                  txt: alertExpr.ui.text,
                  class: "main-l"
                }, null, 8, ["txt"]),
                _createVNode(_component_text_item, {
                  txt: "?",
                  class: "main-l"
                })
              ], 64))
        ], 2)
      ], 64))
    }), 128)),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_svg_item, {
        icon: "allergy",
        styles: "size-m main-m"
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      (substanceReactionList.value.length > 1)
        ? (_openBlock(), _createBlock(_component_toolTip, { key: 0 }, {
            tooltip: _withCtx(() => [
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(substanceReactionList.value, (alertExpr, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "row gap-06"
                  }, [
                    _createVNode(_component_text_item, {
                      txt: alertExpr.ui.text
                    }, null, 8, ["txt"]),
                    _createVNode(_component_text_item, {
                      txt: alertExpr.ui.exprDate,
                      class: "font-s main-l"
                    }, null, 8, ["txt"])
                  ]))
                }), 128))
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                styles: "align-r",
                txt: substanceReactionList.value.length.toString() + ' intolérances / allergies',
                class: "main-alert"
              }, null, 8, ["txt"])
            ]),
            _: 1
          }))
        : (substanceReactionList.value.length === 1)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(substanceReactionList.value, (alertExpr, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "row gap-06"
              }, [
                _createVNode(_component_text_item, {
                  txt: alertExpr.ui.text,
                  class: "main-alert info-max-w"
                }, null, 8, ["txt"]),
                _createVNode(_component_text_item, {
                  txt: alertExpr.ui.exprDate,
                  class: "font-s main-l"
                }, null, 8, ["txt"])
              ]))
            }), 128))
          : (_openBlock(), _createBlock(_component_text_item, {
              key: 2,
              txt: "?",
              class: "main-l"
            }))
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("div", {
      style: {"grid-column":"indic"},
      class: "mtop-04"
    }, null, -1))
  ]))
}
}

})